document.addEventListener('DOMContentLoaded', function () {
  const sectionIds = [
    'shopify-section-template--28157716463942__featured_collection',
    'shopify-section-template--28157716463942__featured_collection_zEkyLw'
  ];

  sectionIds.forEach(function (sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const grid = section.querySelector('ul[role="list"], ul.product-grid, .product-grid');
    if (!grid) return;

    const cards = Array.from(grid.children);
    if (cards.length < 2) return;

    // Hide all cards first
    cards.forEach(function (card) {
      card.style.display = 'none';
    });

    // Shuffle the array
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }

    // Re-append in shuffled order and show only first 4
    cards.forEach(function (card, index) {
      grid.appendChild(card);
      if (index < 4) card.style.display = '';
    });
  });
});




